// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"layout_wrapper__1E1f9","wrapperHead":"layout_wrapperHead__2rMuw","row":"layout_row__1afRD"};